import { handleFiltersChanges, toggleFilterDropdown, stickyFilter } from './filter';
import { addToURL, genericSwitchContent } from './sidebar';
import { scrollToSection } from './scroll-to';

const LARGE = 1279;

const dismissingRelatedProducts = ( parent ) => {
  parent.find( '.close' ).on( 'click', function() {
    parent.removeClass( 'active' );
    parent.parents( '.tab-content' ).find( '.single-product-tile' )
      .removeClass( 'active' ).removeClass( 'not-active' );
    setTimeout( () => {
      parent.remove();
    }, 301 );
  });
};

const removeClonedTemplate = ( panel, source ) => {
  panel.find( source ).removeClass( 'active' );
  setTimeout( () => {
    panel.find( source ).remove();
  }, 301 );
};

const injectClonedTemplate = ( panel, tile, source ) => {
  let clone = source.clone().addClass( 'cloned' ).removeClass( 'hide' );
  let currOrder = tile.data( 'product-order' );
  let offset = 4;
  if ( window.innerWidth < LARGE ) {
    offset = 2;
  }
  let index = offset * Math.ceil( currOrder / offset );

  while ( ! panel.find( '.single-product-tile[data-product-order="' + index + '"' ).length ) {
    index -= 1;

    if ( index < 1 ) {
      index = 1;
      break;
    }
  }

  let target = panel.find( '.single-product-tile[data-product-order="' + index + '"' );

  clone.insertAfter( target );
  let slider = clone.find( '.related-products__inner' ).slick({
    arrows:       true,
    dots:         false,
    slidesToShow: 5,
    swipeToSlide: true,
    infinite:     false,
    responsive:   [
      {
        breakpoint: 1300,
        settings:   {
          slidesToShow: 4
        }
      },
      {
        breakpoint: 1279,
        settings:   {
          slidesToShow: 5
        }
      },
      {
        breakpoint: 1000,
        settings:   {
          slidesToShow: 4
        }
      },
      {
        breakpoint: 800,
        settings:   {
          slidesToShow: 3
        }
      },
      {
        breakpoint: 550,
        settings:   {
          slidesToShow: 2
        }
      },
      {
        breakpoint: 400,
        settings:   {
          slidesToShow: 1
        }
      },
    ],
  });
  clone.find( '.slick-arrow' ).removeClass( 'hide-arrow' );
  setTimeout( () => {
    clone.addClass( 'active' );
    slider.slick( 'setPosition' );
    dismissingRelatedProducts( clone );
  }, 1 );
};

const handleProductClicking = () => {
  let panels = $( '.all-products-tabs__content .products-group .products' );

  panels.each( function() {
    let panel = $( this );
    let tiles = panel.find( '.single-product-tile' );

    tiles.each( function() {
      let tile = $( this );
      let expandLink = tile.find( '.expand-more' );
      expandLink.on( 'click', function() {
        if ( tile.hasClass( 'active' ) ) {

          // Delete clonded template
          removeClonedTemplate( panel, '.expanded-panel.cloned' );
          panel.find( '.single-product-tile' )
            .removeClass( 'active' ).removeClass( 'not-active' );
        } else {

          // Injecting clonded template
          injectClonedTemplate( panel, tile, tile.find( '.expanded-panel' ) );
          panel.find( '.single-product-tile.active' )
            .removeClass( 'not-active' ).addClass( 'active' );

          tile.addClass( 'active' );
          panel.find( '.single-product-tile' ).not( tile ).addClass( 'not-active' );
        }
      });
    });
  });
};

const showContent = () => {
  let url = window.location.href;
  let slug = url.split( '#' )[1];

  if ( slug ) {
    $( '.all-products-tabs .sidebar-name[data-tab-name="' +
    slug + '"]' ).first().addClass( 'active' );
    $( '.all-products-tabs .all-products-tabs__content .products-group[data-tab-name="' +
    slug + '"]' ).addClass( 'active' );
  } else {
    $( '.all-products-tabs .all-products-tabs__content .products-group' )
      .addClass( 'active' );
    $( '.all-products-tabs .sidebar-name' ).first().addClass( 'active' );
  }

  if ( ! slug || slug === 'all' ) {
    $( '.all-products-tabs' ).addClass( 'default' );
  } else {
    $( '.all-products-tabs' ).removeClass( 'default' );
  }

  $( '.all-products-tabs__content' ).removeClass( 'hidden-content' );
};

const switchContent = ( slug ) => {

  genericSwitchContent({
    allCase:       'all',
    activeClass:   'active',
    dataLabel:     'tab-name',
    oldSidebar:    '.all-products-tabs__sidebar .sidebar-name.active',
    activeSidebar: '.all-products-tabs__sidebar .sidebar-name[data-tab-name="' + slug + '"]',
    allContent:    '.all-products-tabs__content .products-group',
    oldContent:    '.all-products-tabs__content .products-group.active',
    activeContent: '.all-products-tabs__content .products-group[data-tab-name="' + slug + '"]',
  }, slug );

  if ( ! slug || slug === 'all' ) {
    $( '.all-products-tabs' ).addClass( 'default' );
  } else {
    $( '.all-products-tabs' ).removeClass( 'default' );
  }
};

const changeContentBySidebar = () => {
  let tabs = $( '.all-products-tabs__sidebar.tab-sidebar .sidebar-name' );

  tabs.on( 'click', function() {
    let currTabName = $( this ).data( 'tab-name' );
    let activeTabName = $( '.all-products-tabs__sidebar .sidebar-name.active' ).data( 'tab-name' );
    if ( currTabName !== activeTabName ) {
      if ( currTabName === 'all' ) {
        addToURL( 'All', false );
      } else {
        addToURL( $( this ).text(), currTabName );
      }
      switchContent( currTabName );
    }
  });
};

const hasBreadcrumbs = () => {

  if ( jQuery( '.module--breadcrumbs' ).length ) {
    jQuery( 'body' ).addClass( 'has-breadcrumbs' );
  }

};

scrollToSection( '.all-products-tabs' );

$( document ).ready( function() {
  showContent();
  handleProductClicking();
  stickyFilter( '.all-products-tabs .refine-results-bar' );
  toggleFilterDropdown( '.all-products-tabs .refine-results-bar .text',
    '.tab-sidebar__wrapper' );
  handleFiltersChanges( 'product' );
  changeContentBySidebar();
  hasBreadcrumbs();
});
